module.exports = __webpack_public_path__ + "img/11.62f626c5.jpg";